<div class="container  pl-0 pr-0">
  <div style="padding: 10px 0px"></div>
  <div class="card shadow mb-5 bg-white rounded col-12 col-md-5 p-0" style="margin: auto; min-height: 250px">
      <div class="card-header">
          Cambio de Contrase&ntilde;a
      </div>
      <form autocomplete="off" (submit)="enviarFormulario()"  [formGroup]="contraseniaForm" class="card-body pr-3">
      <div class="row">
        <mat-form-field class="col-sm-12" appearance="outline">
          <mat-label class="col-form-label">Contrase&ntilde;a Actual:</mat-label>
          <input matInput name="contraseniaActual" formControlName="contraseniaActual" required maxlength="20"
            (keypress)="fnKeyDownPassword($event)" (keyup)="fnKeyDownPasswordMobile($event)"
            (input)="fnInputMaxLength($event);" [type]="hideActual ? 'password' : 'text'">
            <mat-icon matSuffix (click)="hideActual = !hideActual">{{hideActual ? 'visibility_off' : 'visibility'}}</mat-icon>
          <mat-error *ngIf="hasError('contraseniaActual')">{{obtenerMensajeError('contraseniaActual')}}</mat-error>
        </mat-form-field>
      </div>
      <mat-divider class="mb-3"></mat-divider>
      <div formGroupName="passwords">
          <div class="row">
              <mat-form-field class="col-sm-12" appearance="outline">
                <mat-label class="col-form-label">Nueva Contrase&ntilde;a:</mat-label>
                <input matInput name="nuevaContrasenia" formControlName="nuevaContrasenia" required maxlength="20"
                  (keypress)="fnKeyDownPassword($event)" (keyup)="fnKeyDownPasswordMobile($event)"
                  (input)="fnInputMaxLength($event);" [type]="hideNueva ? 'password' : 'text'">
                  <mat-icon matSuffix (click)="hideNueva = !hideNueva">{{hideNueva ? 'visibility_off' : 'visibility'}}</mat-icon>
                <mat-error *ngIf="hasError('nuevaContrasenia')">{{obtenerMensajeError('nuevaContrasenia')}}</mat-error>
              </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="col-sm-12" appearance="outline">
                  <mat-label class="col-form-label">Repetir Contrase&ntilde;a:</mat-label>
                  <input matInput name="repetirContrasenia" formControlName="repetirContrasenia" required maxlength="20"
                    (keypress)="fnKeyDownPassword($event)" (keyup)="fnKeyDownPasswordMobile($event)"
                    (input)="fnInputMaxLength($event);" [type]="hideRepetir ? 'password' : 'text'">
                    <mat-icon matSuffix (click)="hideRepetir = !hideRepetir">{{hideRepetir ? 'visibility_off' : 'visibility'}}</mat-icon>
                  <mat-error *ngIf="hasError('repetirContrasenia')">{{obtenerMensajeError('repetirContrasenia')}}</mat-error>
                </mat-form-field>
                <div *ngIf="hasErrorGroup()" class="mat-error ng-star-inserted pl-4 ml-2 ml-md-2" style=" margin-top: -18px;">La contrase&ntilde;a ingresada no coincide</div>
              </div>
      </div>
        <div mat-dialog-actions class="d-flex justify-content-end mt-2 pr-2">
            <button mat-raised-button type="button" color="warn" class="mr-2" (click)="cancelar()">
                <mat-icon aria-label="icon-button icon">cancel</mat-icon>Cancelar</button>
            <button mat-raised-button type="submit" cdkFocusInitial color="primary"  > 
                <mat-icon>save</mat-icon>
            Cambiar</button>
        </div>
    </form>
  </div>
</div>